export default function Pill({ children }) {
  return <span className="sfm-pill">{children}</span>;
}
